import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CDN_BASE_URL } from 'src/constants/param-constants';
@Component({
    selector: "upsell-doc",
    templateUrl: "upsell-doc.html",
    styleUrls: ["upsell-doc.scss"],
})

export class UpsellDocComponent {
  @Input() docText: string = '';
  @Input() docPicLink: string = `${CDN_BASE_URL}/img/drLaykeBack.jpg`;
  @Input() productName: string = '';
  @Input() buttonYesText: string = 'Yes I want this special added to my order';
  @Input() buttonNoText: string = 'No thanks, I understand that I won\'t see this offer again';
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  nextPage(buttonValue: boolean) {
    this.eventEmitter.emit(buttonValue);
  }
}
